<template>
  <div
    style="
      background: #efefef;
      border: dashed;
      margin: 20px;
      width: calc(100% - 40px);
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
    "
    @drop.prevent="filesDropped"
    @dragover.prevent
  >
    <div class="display-2" style="text-align: center">
      <v-container grid-list-xl text-xs-center>
        <v-layout row wrap>
          <v-flex xs12>
            <ContentTypeIcon height="200px" :type="type" />
            <p style="font-size: 32px">{{ type }}</p>
            <p>Drop XLSX file</p>
            <p style="font-size: 32px">
              or
              <a @click="selectFiles">select from your computer</a>
            </p>
          </v-flex>
          <v-flex xs6 offset-xs3>
            <v-btn
              v-if="!referenceContent"
              color="primary"
              @click.stop="selectContent"
              block
              outline
            >
              <v-icon left>mdi-folder-search-outline</v-icon>
              Select {{ ContentBodyConstructor.BULK_UPLOAD.reference_title }}
            </v-btn>
            <template v-if="referenceContent">
              <p style="font-size: 16px">
                {{ ContentBodyConstructor.BULK_UPLOAD.reference_title }}: [{{
                  referenceContent.header.metadata.custom_id
                }}] {{ referenceContent.header.metadata.title }}
                <a @click="referenceContent = false">[Change]</a>
              </p>
            </template>
            <bulk-upload-download-templates
              :type="type"
              :referenceContent="referenceContent"
              :disabled="!referenceContent"
            />
          </v-flex>
        </v-layout>
      </v-container>
    </div>
  </div>
</template>

<script>
import XLSX from "xlsx";
import { mapActions } from "vuex";
import { fileToArrayBuffer } from "@/utils/bulkUpload";
import { ContentTypeIcon } from "plant-common";
import { selectFileFromComputer } from "@/utils/bulkUpload";

import {
  STORE_NOTIFICATIONS_NAME,
  ACTION_NOTIFICATIONS_ERROR
} from "@/store_constants/notifications";

import BulkUploadDownloadTemplates from "./DownloadTemplates.vue";
import PServiceContent from "plant-common/src/services/PServiceContent";

import { ContentOperationStatus } from "plant-common/src/models/contentOperationStatus";
import { getContentBodyConstructorFrom } from '@/classes/content/contentBodyFunctions';

export default {
  name: "BulkUploadUploadXls",
  props: ["type"],
  components: {
    ContentTypeIcon,
    BulkUploadDownloadTemplates
  },
  data() {
    return {
      allowed_types: [],
      new_contents: [],
      referenceContent: false
    };
  },
  computed: {
    ContentBodyConstructor() {
			return getContentBodyConstructorFrom(this.type);
    }
  },
  methods: {
    ...mapActions(STORE_NOTIFICATIONS_NAME, {
      error: ACTION_NOTIFICATIONS_ERROR
    }),
    async selectContent() {
      this.referenceContent = await PServiceContent.selectContent();
    },
    async selectFiles() {
      var [file] = await selectFileFromComputer(
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        false
      );
      this.uploadXlsxTemplate(file);
    },
    filesDropped(evt) {
      if (evt.dataTransfer.files.length !== 1) {
        alert("You can only drop one file");
        return;
      }
      var file = evt.dataTransfer.files[0];
      if (
        file.type !==
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      ) {
        alert("You can only drop a XLSX file.");
        retur;
      }
      this.uploadXlsxTemplate(file);
    },
    async uploadXlsxTemplate(file) {
      var file_buffer = await fileToArrayBuffer(file);
      var wb = XLSX.read(file_buffer, { type: "array" });
      var import_data = XLSX.utils.sheet_to_json(wb.Sheets["IMPORT-DATA"]);
      var import_config = XLSX.utils.sheet_to_json(
        wb.Sheets["IMPORT-CONFIG"]
      )[0];
      if (import_data.length === 0) {
        this.showAlert(`Nothing to import.`);
        return;
      }
      if (!(import_config && import_config.type && import_config.$ref)) {
        this.showAlert(
          `Malformed File: IMPORT-CONFIG not defined correctly. Please, download specific template and try again.`
        );
        return;
      }
      this.allowed_types = [import_config.type];
      for (var new_content of import_data) {
        var { custom_id, title, custom_revision, ...custom_columns } =
          new_content;
        var body = new this.ContentBodyConstructor(
          custom_columns,
          import_config.$ref
        );
        this.new_contents.push({
          custom_id: custom_id + "",
          title: title + "",
          body,
          valid: true,
          custom_revision: custom_revision ? custom_revision + "" : "",
          status: ContentOperationStatus.notStarted
        });
      }
      this.$emit("upload-finished", this.new_contents);
    },
    showAlert(message) {
      this.error({ message, timeout: -1 });
    }
  }
};
</script>

<style>
.type-name {
  font-size: 32px;
}
</style>